import React, { useEffect, useState } from 'react';
import Layout from '../../common/Layout';
import { dispatchMmvData } from '../../store/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import { GetDataWithToken, PostDataWithToken } from '../../constants/ApiHelper';
import { toast } from 'react-toastify';

const MmvMaster = () => {
    const mmvData = useSelector(state => state?.root?.mmvData);
    const dispatch = useDispatch();

    const [insurerData, setInsurerData] = useState([]);
    const [vehicleType, setVehicleType] = useState('');
    const [insurer, setInsurer] = useState('');
    const [insurerName, setInsurerName] = useState(''); 
    console.log("insurer:", insurer);
    
    const [uploadType, setUploadType] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);

    // ================= VEHICLE =================
    const handleVehicle = (val) => {
        setVehicleType(val);
        setInsurer('');
        dispatchMmvData('vehicleType', val);
    };

    // ================= INSURERS =================
    const loadInsurers = async () => {
        try {
            const res = await GetDataWithToken('/insurers/getAllInsurer');
            if (res?.success) setInsurerData(res?.data || []);
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        if (vehicleType && mmvData?.apiUrl) {
            loadInsurers();
        }
    }, [vehicleType, mmvData?.apiUrl]);

    // ================= INSURER =================
    const handleInsurer = (val, list) => {
        debugger
setInsurer(val);
        const selected = list.find(x => x.insurerId == val);
setInsurerName(selected?.mappingName || '');
        dispatchMmvData('insurerId', val);
        dispatchMmvData('insurerName', selected?.insurerName || '');
        dispatchMmvData('mappingName', selected?.mappingName || '');
    };

    // ================= FILE =================
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const ext = file.name.split('.').pop().toLowerCase();
        const allowed = ['csv', 'xls', 'xlsx'];

        if (!allowed.includes(ext)) {
            alert('Only CSV, XLS, XLSX allowed');
            e.target.value = '';
            return;
        }

        setSelectedFile(file);
    };

    // ================= UPLOAD (FIXED 100%) =================
    const handleUpload = async () => {
        if (!vehicleType || !insurer || !uploadType || !selectedFile) {
            toast.error('Please fill all fields');
            return;
        }

        const formData = new FormData();
        formData.append('masterType', uploadType);
        formData.append('vehicleType', vehicleType);
        formData.append('insurer', insurerName); 
        formData.append('file', selectedFile);

        // 🔥 DEBUG (IMPORTANT)
        for (let pair of formData.entries()) {
            console.log('FORMDATA:', pair[0], pair[1]);
        }

        try {
            setLoading(true);

            const token = localStorage.getItem('token');

            const response = await fetch('https://uatmasterapi.flaskitsolutions.com/master-data/upload', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`
                    // ❗ NEVER set Content-Type here
                },
                body: formData
            });

            const data = await response.json();

            console.log('UPLOAD RESPONSE:', data);

            if (response) {
                toast.success('Upload successful');

                setVehicleType('');
                setInsurer('');
                setUploadType('');
                setSelectedFile(null);
            } else {
                toast.error(data?.message || 'Upload failed');
            }

        } catch (error) {
            console.log('UPLOAD ERROR:', error);
            toast.error('Upload error');
        } finally {
            setLoading(false);
        }
    };

    //    const handleUpload = async () => {
    //     if (!vehicleType || !insurer || !uploadType || !selectedFile) {
    //         alert('Please fill all fields');
    //         return;
    //     }

    //     const formData = new FormData();
    //     formData.append('masterType', uploadType);
    //     formData.append('vehicleType', vehicleType);
    //     formData.append('insurerId', insurer);
    //     formData.append("file", selectedFile);

    //     try {
    //         setLoading(true);

    //         const res = await PostDataWithToken('/master-data/upload', formData
    //         );

    //         const data = await res.json();

    //         if (data?.success) {
    //             alert('Upload successful');

    //             // reset
    //             setVehicleType('');
    //             setInsurer('');
    //             setUploadType('');
    //             setSelectedFile(null);
    //         } else {
    //             alert(data?.message || 'Upload failed');
    //         }

    //     } catch (error) {
    //         console.log('UPLOAD ERROR:', error);
    //         alert('Upload error');
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    // ================= UI =================
    return (
        <Layout>
            <div className="mt-5">
                <div className="card">
                    <div className="card-body">
                        <div className="row">

                            {/* VEHICLE TYPE */}
                            <div className="col-md-4">
                                <label>Vehicle Type</label>
                                <select
                                    className="form-control"
                                    value={vehicleType}
                                    onChange={(e) => handleVehicle(e.target.value)}
                                >
                                     <option value=''>Select Vehicle</option>
                      <option value='2w'>Two Wheeler</option>
                      <option value='4w'>Private Car</option>
                      <option value='pcv'>Passenger Carrying Vehicle</option>
                      <option value='gcv'>Goods Carrying Vehicle</option>
                      <option value='misc'>Miscellaneous Vehicle</option>
                                </select>
                            </div>

                            {/* INSURER */}
                            <div className="col-md-4">
                                <label>Insurer</label>
                                <select
                                    className="form-control"
                                    value={insurer}
                                    onChange={(e) => handleInsurer(e.target.value, insurerData)}
                                >
                                    <option value="">Select Insurer</option>
                                    {insurerData.map((i, idx) => (
                                        <option key={idx} value={i.insurerId}>
                                            {i.mappingName}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* MASTER TYPE */}
                            <div className="col-md-4">
                                <label>Master Type</label>
                                <select
                                    className="form-control"
                                    value={uploadType}
                                    onChange={(e) => setUploadType(e.target.value)}
                                >
                                    <option value="">Select Master Type</option>
                                    <option value="mmv">MMV</option>
                                    <option value="rto">RTO</option>
                                    <option value="pincode">Pincode</option>
                                    <option value="relation">Relation</option>
                                    <option value="prevInsurer">Prev Insurer</option>
                                    <option value="financier">Financier</option>
                                    <option value="occupation">Occupation</option>
                                    <option value="exshowroom">Ex Showroom</option>
                                </select>
                            </div>

                            {/* FILE */}
                            <div className="col-md-4 mt-3">
                                <label>File</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    accept=".csv,.xls,.xlsx"
                                    onChange={handleFileChange}
                                />
                            </div>

                            {/* BUTTON */}
                            <div className="col-md-4 mt-3 ">
                              <label></label>
                    
                                <button
                                    className="btn btn-sec w-100"
                                    onClick={handleUpload}
                                    disabled={loading}
                                >
                                    {loading ? 'Uploading...' : 'Upload'}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
             {loading && (
                <div className="loader-overlay">
                    <div className="text-center">
                        <div
                            className="spinner-border text-primary"
                            role="status"
                        />
                        <h5 className="mt-3">
                            Updating Status...
                        </h5>
                    </div>
                </div>
            )}
        </Layout>
    );
};

export default MmvMaster;